var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("IP Voice")]),_c('ag-grid-vue',{staticClass:"ag-theme-balham",attrs:{"domLayout":"autoHeight","columnDefs":_vm.columnDefs,"rowData":_vm.rowData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }